import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { OrderIdParams } from '@src/core/entities';
import { selectWizardOrderId } from '@src/features/order/pages/upsert-mission-page/redux';

export const useWizardOrderId = (): string => {
  const params = useParams<OrderIdParams>();
  const wizardOrderId = useSelector(selectWizardOrderId);
  return params.orderId ?? wizardOrderId ?? '';
};

export const useHasWizardOrder = (): boolean => Boolean(useWizardOrderId());
